export const ownerscabinImageOptions = {
  angle: 'ownerscabin',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Worktop: 1,
    Fabric: 1,
    Handrail: 1,
    Layout: 1,
    BerthInfill: 1,
    FabricCabins: 1,
    AftCabinShelving: 1,
    SeaBerths: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'Floorboard',
      dependency: 'Layout'
    },
    {
      option: 'Fabric',
      dependency: 'Worktop'
    },
    {
      option: 'FabricCabins',
      dependency: 'BerthInfill'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP55/views/ownerscabin.js